module.exports = __webpack_public_path__ + "img/faqs.5e075011.png";